// Modules
import { useFormContext } from "react-hook-form"

// Components
import ImageUpload from "~components/imageUpload/ImageUpload"
import { WizardStepContainer } from "~styled/wizard"

interface StepProps {
  isVisible: boolean
}

const MessageModalStep2 = ({ isVisible }: StepProps) => {
  const { register, setValue, getValues, unregister } = useFormContext()

  return (
    <WizardStepContainer className={isVisible ? "visible" : ""}>
      <ImageUpload
        className={"cover"}
        key="cover"
        name="cover"
        label="Select your cover image"
        required={false}
        {...{ register, setValue, getValues, unregister }}
      />
    </WizardStepContainer>
  )
}

export default MessageModalStep2
